// Styles
import styles from './CustomVueList.module.css';

/**
 * CustomVueListContainer
 * @param {object} props
 * @param {import('react').ReactNode} props.children
 * @param {string} [props.width] - Overrides default panel width (e.g. "480px")
 * @returns {JSX.Element} CustomVueListContainer component
 */
function CustomVueListContainer({ children, width }) {
  const containerStyle = width
    ? /** @type {React.CSSProperties} */ ({ '--width': width })
    : undefined;

  return (
    <div
      className={styles.container}
      style={containerStyle}
    >
      {children}
    </div>
  );
}

/**
 * CustomVueList
 * @param {object} props
 * @param {import('react').ReactNode} props.children
 * @returns {JSX.Element} CustomVueList component
 */
export function CustomVueList({ children }) {
  return <div className={styles.list}>{children}</div>;
}

export default CustomVueListContainer;
